import { render, staticRenderFns } from "./CvInterests.vue?vue&type=template&id=50d4395c&scoped=true"
import script from "./CvInterests.vue?vue&type=script&lang=js"
export * from "./CvInterests.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50d4395c",
  null
  
)

export default component.exports